import styled from '@emotion/styled';
import { color, COLOR_VARIANTS } from '@tajawal/ct-web-design-system';
import { Skeleton } from '@mui/material';
import { shouldForwardProp } from '@/utils/style.utils';

const SkeletonWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
`;

const WrapperHeader = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-start;
  align-items: center;
  padding: 20px 16px;
  border-bottom: solid 1px ${color(COLOR_VARIANTS.GAINSBORO)};

  h2 {
    flex: 1;
    text-align: center;
  }
`;

const SkeletonBody = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
  padding: 32px;
`;

const SkeletonHeader = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
`;

const SkeletonHeaderDuration = styled.div`
  display: flex;
  gap: 4px;
  margin-top: 4px;
`;

const SkeletonLegs = styled.div`
  margin-top: 24px;
  border: 1px solid ${color(COLOR_VARIANTS.GAINSBORO)};
  width: 542px;
  height: 252px;
  position: relative;
  display: flex;
  justify-content: left;
  gap: 5px;
  border-radius: 12px;
  padding: 16px;
`;

const SkeletonSection = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  gap: 5px;
  align-items: center;
`;

const RectangleSkeleton = styled(Skeleton)`
  border-radius: 4px;
`;

const BlueCircle = styled('div', { shouldForwardProp })<{ $isLastCircle?: boolean }>`
  width: 12px;
  height: 12px;
  background-color: ${color(COLOR_VARIANTS.GAINSBORO)};
  border-radius: 50%;
  position: relative;

  &:before {
    position: absolute;
    content: '';
    display: block;
    width: 1px;
    height: 60px;
    ${({ $isLastCircle }) => ($isLastCircle ? 'bottom: 16px;' : 'top: 16px;')}
    left: 5px;
    background-color: ${color(COLOR_VARIANTS.GAINSBORO)};
  }
`;

const SkeletonSectionInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: flex-start;
`;

const SkeletonAirlineInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  align-self: flex-start;
`;

const SkeletonBaggage = styled.div`
  margin-top: 16px;
  display: flex;
  gap: 16px;
`;

const BaggageContainer = styled.div`
  border: 1px solid ${color(COLOR_VARIANTS.GAINSBORO)};
  width: 263px;
  height: 164px;
  border-radius: 12px;
`;

const BaggageHeader = styled.div`
  background-color: ${color(COLOR_VARIANTS.GHOSTWHITE)};
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  height: 44px;
`;

const BaggageContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px;
`;

const BaggageItem = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 8px;
`;

const SkeletonPricing = styled.div`
  width: 100%;
  height: 84px;
  padding: 16px;
  display: flex;
  border-top: 1px solid ${color(COLOR_VARIANTS.GAINSBORO)};
  justify-content: space-between;
`;

const SkeletonPricingTotal = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: center;
`;

const ButtonSkeleton = styled(Skeleton)`
  border-radius: 24px;
`;

export default {
  SkeletonWrapper,
  WrapperHeader,
  SkeletonBody,
  SkeletonSection,
  RectangleSkeleton,
  BlueCircle,
  SkeletonHeader,
  SkeletonLegs,
  SkeletonBaggage,
  SkeletonSectionInfo,
  SkeletonAirlineInfo,
  BaggageContainer,
  SkeletonHeaderDuration,
  BaggageHeader,
  BaggageContent,
  BaggageItem,
  SkeletonPricing,
  SkeletonPricingTotal,
  ButtonSkeleton,
};
